import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchContracts(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/contracts', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        createContract(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/contracts', payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchContract(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/contracts/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateContract(ctx, { id, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/contracts/${id}`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteContract(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/contracts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}